import moment from 'moment';
import { BillEstimateOrderItemDto } from '@css-xp/common-services/src/api/gateways/ccp-gateways/src/ccp-api-order';

export const getBillPeriod = (items?: BillEstimateOrderItemDto['items'], isBulkEdit = true): string | undefined => {
  if (items?.length) {
    // finding out billing period of order line item with non negative total
    const nonNegativeLineItems = items.filter((item) => item.total >= 0);
    if (nonNegativeLineItems?.length) {
      const billPeriod = nonNegativeLineItems.reduce((acc, item) => {
        if (item.billPeriod?.start) {
          if (!acc.start || item.billPeriod.start < acc.start) {
            acc.start = item.billPeriod?.start;
          }
        }
        if (item.billPeriod?.end) {
          if (!acc.end || item.billPeriod.end > acc.end) {
            acc.end = item.billPeriod?.end;
          }
        }
        return acc;
      }, nonNegativeLineItems[0].billPeriod ?? {});
      // displaying billing period of earliest start and latest end date

      if (billPeriod?.start && billPeriod?.end) {
        if (isBulkEdit) {
          return `${moment.utc(billPeriod.start).format('MMM DD, YYYY')} - ${moment
            .utc(billPeriod.end)
            .format('MMM DD, YYYY')}`;
        }
        return `${moment.utc(billPeriod.start).format("MMM DD 'YY")} - ${moment
          .utc(billPeriod.end)
          .format("MMM DD 'YY")}`;
      }
    }
  }
};
